module.exports = {"pipeline":{"name":"pipeline-multipleChoiceQuestion","title":"多选题","type":"qs-choice","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-multipleChoiceQuestion/package.json
// module id = 254
// module chunks = 1